import React from "react";
import { Spinner, Alert } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../auth/AuthProvider";

const LoginPage = () => {
  const history = useHistory();
  const { ready, authenticated } = useAuth();

  React.useEffect(() => {
    if (!ready) return;
    if (authenticated) history.replace("/home");
  }, [ready, authenticated, history]);

  return (
    <div
      style={{
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
      }}
    >
      <div style={{ width: "100%", maxWidth: 520, textAlign: "center" }}>
        <Spinner animation="border" role="status" style={{ marginBottom: 16 }}>
          <span className="sr-only">A carregar...</span>
        </Spinner>
        <h4 style={{ marginBottom: 8 }}>A iniciar sessão…</h4>
        <p style={{ marginBottom: 16, opacity: 0.8 }}>
          Aguarde enquanto concluímos a autenticação.
        </p>
        <Alert variant="light" style={{ textAlign: "left" }}>
          Se esta página não avançar em alguns segundos, tente atualizar (F5) ou
          fechar outras abas deste site.
        </Alert>
      </div>
    </div>
  );
};

export default LoginPage;
